// extracted by mini-css-extract-plugin
module.exports = {"root":"Node_root__NM09j","row":"Node_row__1x5QX","label":"Node_label__2s2y_","footer":"Node_footer__2ZrE8"};